import en from './locales/en/translations.json';
import fr from './locales/fr/translations.json';
import es from './locales/es/translations.json';
import it from './locales/it/translations.json';
import pt from './locales/pt/translations.json';
import de from './locales/de/translations.json';
import zh from './locales/zh/translations.json';

export const TRANSLATIONS = {
    en: {
        translation: en,
    },
    fr: {
        translation: fr,
    },
    es: {
        translation: es,
    },
    it: {
        translation: it,
    },
    pt: {
        translation: pt,
    },
    de: {
        translation: de,
    },
    zh: {
        translation: zh,
    },
};

// export const SUPPORTED_LANGUAGES = Object.keys(TRANSLATIONS);
export const DEFAULT_LANGUAGE = 'en';
